import set from '../set.js';
import deepFind from '../_helpers/deepfind.js';
import forEach from '../_helpers/foreach.js';
import apply from '../_helpers/apply.js';
import assign from '../_helpers/assign.js';
// the flags meant for the source property only; "silent" reaches the target
var sourceOnlyOptions = ['protector', 'skipMediator', 'fromMediator', 'force', 'forceHTML', 'silentHTML'];
// creates event handler for target object which will be fired when a source is changed
export default function createCalcHandler(_ref) {
  var object = _ref.object,
    eventOptions = _ref.eventOptions,
    allSources = _ref.allSources,
    target = _ref.target,
    def = _ref.def,
    handler = _ref.handler;
  // the id of the latest calculation; a promise of an older one doesn't set the target
  var latestCalcId = 0;
  return function calcHandler(changeEvent) {
    if (changeEvent === void 0) {
      changeEvent = {};
    }
    var values = [];
    var protector = changeEvent.protector || {};
    var sourceEventOptions = assign({}, changeEvent);
    forEach(sourceOnlyOptions, function (name) {
      delete sourceEventOptions[name];
    });
    // a deep source hears skipCalc here; a plain one is skipped by set; a removed target is not written back
    if (changeEvent.skipCalc || !def.props[target]) {
      return;
    }
    var protectKey = def.id + ":" + target;
    var promiseCalc = eventOptions.promiseCalc;
    // a calc already on this path is a cycle; a target reached by two paths (a diamond) runs on each
    if (protectKey in protector) {
      return;
    }
    var nextProtector = assign({}, protector);
    nextProtector[protectKey] = true;
    var setEventOptions = assign({
      protector: nextProtector
    }, eventOptions, sourceEventOptions);
    forEach(allSources, function (_ref2) {
      var sourceObject = _ref2.sourceObject,
        sourceKey = _ref2.sourceKey,
        isDelegated = _ref2.isDelegated;
      var value = isDelegated ? deepFind(sourceObject, sourceKey) : sourceObject[sourceKey];
      values.push(value);
    });
    var targetValue = apply(handler, object, values);
    if (promiseCalc) {
      latestCalcId += 1;
      var calcId = latestCalcId;
      // a rejection is left unhandled, so the original error reaches the environment
      // a thenable needs no global Promise, which IE 11 lacks without a polyfill
      var promise = targetValue && typeof targetValue.then === 'function' ? targetValue : Promise.resolve(targetValue);
      promise.then(function (promiseResult) {
        if (calcId === latestCalcId) {
          set(object, target, promiseResult, setEventOptions);
        }
      });
    } else {
      set(object, target, targetValue, setEventOptions);
    }
  };
}